import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../axiosConfig";
import PortalLogo from "./utils/PortalLogo";

const SignInLayer = () => {
  const navigate = useNavigate();
  const [rfc, setRfc] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
 
  const [logoUrl, setLogoUrl] = useState("assets/images/auth/logo.png")
 

   
  useEffect(() => {

    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem("roles");
    localStorage.removeItem("idUser");
    localStorage.removeItem("userObj");
 
    localStorage.removeItem("notif_cache_v1");


     const loadTheme = async () => {
      try {
        const res = await api.get("/perfil",{
          headers: { "X-Skip-Auth-Redirect": "true" }
        });

        if (res.status === 200 && res.data) {
          console.log("Perfil / theme:", res.data);
          const theme = res.data;

          // Asegúrate que vengan como #RRGGBB o colores válidos CSS
          if (theme.colorPrimario) {
            document.documentElement.style.setProperty( "--primary-600", theme.colorPrimario );
            document.documentElement.style.setProperty(  "--primary-700", theme.colorPrimario );
            document.documentElement.style.setProperty( "--primary-50", theme.colorPrimario );
          }

          if (theme.colorFondo) {
            document.documentElement.style.setProperty( "--neutral-50", theme.colorFondo );
          }
          

          if (theme.colorPrimario){
             localStorage.setItem("color_primario", theme.colorPrimario);
          }

          if (theme.colorFondo){ 
             localStorage.setItem("color_fondo", theme.colorFondo);
          }

          // Si ya tienes logo en el perfil, aquí solo lo guardas para usarlo en el header
          // Por ejemplo:
           if (theme.logoPrimario) {
             localStorage.setItem("portal_logo_url", theme.logoPrimario);
              setLogoUrl(theme.logoPrimario);
           }
        }
      } catch (error) {
        console.error("Error cargando tema / perfil:", error);
        // Aquí puedes poner colores por defecto si falla
        // document.documentElement.style.setProperty("--primary-600", "#0055A5");
      }
    };

    loadTheme();
    

  }, []);

 

  const handleSubmit = async (e) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    setError("");
    setLoading(true);

    try {
      const res = await api.post(
        "/authenticate",
        { username: rfc, password },
        {
          // 1) No rechaces automáticamente 4xx/5xx para poder inspeccionar.
          validateStatus: () => true,
          // 2) Señal opcional para saltar interceptor (ver nota abajo).
          headers: { "X-Skip-Auth-Redirect": "true" }
        }
      );

      if (res.status < 200 || res.status >= 300) {
        const msg = "Credenciales inválidas. Intenta de nuevo.";
        setError(msg);
        return; // NO navegar, NO recargar
      }

      const { token, refreshToken, user, roles } = res.data;
      localStorage.setItem("accessToken", token);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("user", user?.rfc || rfc);
      localStorage.setItem("idUser", user?.idUsuario );
      localStorage.setItem("roles", roles);

      localStorage.setItem("userObj", JSON.stringify( user ) );
      navigate("/index-9");
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "Credenciales inválidas. Intenta de nuevo.";
      //const msg =  "Credenciales inválidas. Intenta de nuevo.";

      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className='auth bg-base d-flex flex-wrap'>
      <div className='auth-left d-lg-block d-none'>
        <div className='d-flex align-items-center flex-column h-100 justify-content-center'>
          <img src='assets/images/auth/auth-img.png' alt='' />
        </div>
      </div>
      <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>
        <div className='max-w-464-px mx-auto w-100'>
          <div className='text-center mb-5'>
            <div className='row'>
              <div className='col-md-4'></div>
              <div className='col-md-4 mb-3'>
               <img src={logoUrl} />
              </div>
              <div className='col-md-4'></div>
            </div>
            <h4 className='mb-12 text-primary-600'>Portal del Trabajador</h4>
          </div>

          <h5 className='mb-12'>Iniciar sesión</h5>
          <p className='mb-32 text-secondary-light text-lg'>
            ¡Bienvenido de nuevo! Por favor, introduzca sus datos
          </p>

          {error && (
            <div className='alert alert-danger text-sm mb-16'>{error}</div>
          )}

          <form onSubmit={handleSubmit}>
            <div className='icon-field mb-16'>
              <span className='icon top-50 translate-middle-y'>
                <Icon icon='mage:user-square' />
              </span>
              <input
                type='text'
                className='form-control h-56-px bg-neutral radius-12'
                placeholder='RFC'
                value={rfc}
                onChange={(e) => setRfc(e.target.value)}
                onBlur={ (e) =>  setRfc((s) =>  s.toUpperCase()   )   }
                required
                maxLength={13}
                minLength={12} />
            </div>
            <div className='position-relative mb-20'>
              <div className='icon-field'>
                <span className='icon top-50 translate-middle-y'>
                  <Icon icon='solar:lock-password-outline' />
                </span>
                <input
                  type={showPass ? "text" : "password"}
                  className='form-control h-56-px bg-neutral radius-12'
                  id='your-password'
                  placeholder='Contraseña'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={8} />
              </div>

               {/* Botón ojo */}
                              <button
                                type="button"
                                className="position-absolute end-0 top-50 translate-middle-y me-16 border-0 bg-transparent text-secondary-light"
                                onClick={() => setShowPass((s) => !s)}
                                aria-label={showPass ? "Ocultar contraseña" : "Mostrar contraseña"}
                                title={showPass ? "Ocultar contraseña" : "Mostrar contraseña"}
                              >
                                <Icon icon={showPass ? "mdi:eye-off-outline" : "mdi:eye-outline"} width="22" height="22" />
                              </button>

            </div>



            <div className='d-flex justify-content-between gap-2'>
              <Link to='/forgot-password' className='text-primary-600 fw-medium'>
                ¿Has olvidado tu contraseña?
              </Link>
            </div>

            <button
              type='submit'
              className='btn btn-primary-50 text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32' >
              Iniciar Sesión
            </button>

            <div className='mt-32 center-border-horizontal text-center'>
              <span className='bg-base z-1 px-4'>O</span>
            </div>

            <div className='mt-32 text-center text-sm'>
              <p className='mb-0'>
                No tienes cuenta?{" "}
                <Link to='/registro' className='text-primary-600 fw-semibold'>
                  Regístrate
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;